import resultImgBest from "../img/resultBest.jpeg";
import resultImgGood from "../img/resultGood.jpeg";
import resultImgSoso from "../img/resultSoso.jpeg";
import resultImgBad from "../img/resultBad.jpeg";
import resultImgWorse from "../img/resultWorse.jpeg";

// 각 mbti 매치 별로 궁합 설명 문자열 값 리턴
export const getMbtiMatchPercent = (me, you) => {
  switch (me) {
    case "INFP":
      if (you === "ENFJ" || you === "ENTJ") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["INFP", "ENFP", "INFJ", "INTJ", "INTP", "ENTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ENFP":
      if (you === "INFJ" || you === "INTJ") {
        return [
          "best",
          "우리 궁합은 천생연분🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["INFP", "ENFP", "ENFJ", "ENTJ", "INTP", "ENTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "INFJ":
      if (you === "ENFP" || you === "ENTP") {
        return [
          "best",
          "우리 궁합은 천생연분🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["INFP", "INFJ", "ENFJ", "INTJ", "ENTJ", "INTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ENFJ":
      if (you === "INFP" || you === "ISFP") {
        return [
          "best",
          "우리 궁합은 천생연분🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["ENFP", "INFJ", "ENFJ", "INTJ", "ENTJ", "INTP", "ENTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "INTJ":
      if (you === "ENFP" || you === "ENTP") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["INFP", "INFJ", "ENFJ", "INTJ", "ENTJ", "INTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (
        ["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)
      ) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      }
    case "ENTJ":
      if (you === "INFP" || you === "INTP") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["ENFP", "INFJ", "ENFJ", "INTJ", "ENTJ", "ENTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      }
    case "INTP":
      if (you === "ENTJ" || you === "ESTJ") {
        return [
          "best",
          "우리 궁합은 천생연분🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["INFP", "ENFP", "INFJ", "ENFJ", "INTJ", "INTP", "ENTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (
        ["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)
      ) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      }
    case "ENTP":
      if (you === "INFJ" || you === "INTJ") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (
        ["INFP", "ENFP", "ENFJ", "ENTJ", "INTP", "ENTP"].includes(you)
      ) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (
        ["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)
      ) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      }
    case "ISFP":
      if (you === "ENFJ" || you === "ESFJ" || you === "ESTJ") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ESFP":
      if (you === "ISFJ" || you === "ISTJ") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP", "ESFJ", "ESTJ"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ISTP":
      if (you === "ESFJ" || you === "ESTJ") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP", "ISFJ", "ISTJ"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ESTP":
      if (you === "ISFJ") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP", "ESFJ", "ISTJ", "ESTJ"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["ISFP", "ESFP", "ISTP", "ESTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ISFJ":
      if (you === "ESFP" || you === "ESTP") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["ISFJ", "ESFJ", "ISTJ", "ESTJ"].includes(you)) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (["ISFP", "ISTP"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ESFJ":
      if (you === "ISFP" || you === "ISTP") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["ISFJ", "ESFJ", "ISTJ", "ESTJ"].includes(you)) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (["ESFP", "ESTP"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ISTJ":
      if (you === "ESFP") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["ISFJ", "ESFJ", "ISTJ", "ESTJ"].includes(you)) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (["ISFP", "ISTP", "ESTP"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["INTJ", "ENTJ", "INTP", "ENTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    case "ESTJ":
      if (you === "INTP" || you === "ISFP" || you === "ISTP") {
        return [
          "best",
          "우리 궁합은 천생연분 🥰",
          `${me}와 ${you}는 서로가 서로를 더 나은 사람으로 만들어 주는 천생연분 관계예요. 잘맞는 부분이 많아서 트러블 없이 자연스럽게 좋은 관계로 발전할 수 있는 사이예요.`,
          <img src={resultImgBest}/>
        ];
      } else if (["ISFJ", "ESFJ", "ISTJ", "ESTJ"].includes(you)) {
        return [
          "good",
          "좋은 관계로 발전 가능! 🤝🏻",
          `${me}와 ${you}는 천생연분은 아니지만 노력한다면 충분히 좋은 관계로 발전이 가능한 사이예요. 안맞는 부분도 많겠지만 서로 이해하고 노력한다면 누구보다 돈독한 사이가 될 수 있을거예요.`,
          <img src={resultImgGood}/>
        ];
      } else if (["ESFP", "ESTP"].includes(you)) {
        return [
          "soso",
          "맞는 것 안맞는 것, 반반! ",
          `${me}와 ${you}는 서로 맞는 부분과 맞지 않는 부분이 비슷하게 있어서 서로 큰 충돌이나 관계에 발전없이 물 흐르듯이 흘러가는 사이예요. 관계에 발전을 주고 싶다면 서로 맞지 않는 부분을 맞춰보려 노력해보는건 어떨까요?`,
          <img src={resultImgSoso}/>
        ];
      } else if (["INTJ", "ENTJ", "ENTP"].includes(you)) {
        return [
          "bad",
          "최악은 아니지만 좋지도 않아요 😐",
          `${me}와 ${you}는 최악도 좋지도 않은 사이로 누군가의 노력이 없이는 크게 발전할 기미가 보이지 않는 사이예요. 서로에게 오해가 쌓이지 않도록 조심해야하며 관계에 적절한 선을 유지하는게 좋을것 같아요.`,
          <img src={resultImgBad}/>
        ];
      } else {
        return [
          "bad",
          "우리 궁합 다시 생각해봐요.. 🥹 ",
          `${me}와 ${you}는 상대를 이해하는 것도 피곤하며 서로를 완전히 이해하는 데에도 어려움이 있어요. 잘맞지 않는 상대와 잘지내보려고 노력하는것도 좋지만 관계를 멈추는 능력도 가끔씩은 필요하다고 생각해요.`,
          <img src={resultImgWorse}/>
        ];
      }
    default:
      break;
  }
};

// best / good / bad 에 따른 결과에 따라서 숫자 범위에서 랜덤으로 궁합도 생성
export const getRandomPercentByMatch = (match) => {
  switch (match) {
    // 80 - 100
    case "best":
      return Math.floor(Math.random() * (100 - 80 + 1)) + 80;
    // 60 - 80
    case "good":
      return Math.floor(Math.random() * (80 - 60 + 1)) + 60;
    // 40 - 60
    case "soso":
      return Math.floor(Math.random() * (60 - 40 + 1)) + 40;
    // 30 - 40
    case "bad":
      return Math.floor(Math.random() * (40 - 30 + 1)) + 30;
    // 20 - 30
    case "worse":
      return Math.floor(Math.random() * (30 - 20 + 1)) + 20;
    default:
      return 50;
  }
};
